import { Base } from 'src/api/Base'

export class ProductBudgetAPI extends Base {
  static get entity() {
    return 'product-budget'
  }

  static async getExpenses({ productId }) {
    const params = {
      ...this.datepicker,
      productId,
    }
    const { data } = await this.request().get(`/${this.entity}/expenses`, {
      params,
    })

    return data
  }

  static async getTemplates() {
    const params = {
      ...this.datepicker,
    }

    const { data } = await this.request().get(`/${this.entity}/templates`, {
      params,
    })

    return data
  }

  static async copyActualToPlanned({ productId }) {
    const params = {
      ...this.datepicker,
      productId,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/copy-actual-to-planned`, {}, { params })

    return data
  }

  static async copyPlannedToActual({ productId }) {
    const params = {
      ...this.datepicker,
      productId,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/copy-planned-to-actual`, {}, { params })

    return data
  }

  static async createTemplate({ name, type, percents }) {
    const { dealerGroupId } = this.datepicker

    const params = {
      dealerGroupId,
    }

    const body = {
      name,
      type,
      percents,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/template-create`, body, { params })

    return data
  }

  static async saveCampaign({ budgetType, budget, percents, campaign, productId }) {
    const params = { ...this.datepicker, productId }

    const body = {
      budgetType,
      budget,
      campaign,
      percents,
    }
    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/save-campaign`, body, { params })

    return data
  }

  static async saveAll({
    campaigns,
    budgetType,
    budget,
    samePercentsOnCampaigns,
    percents,
    campaignPercents,
    productId,
  }) {
    const params = {
      ...this.datepicker,
      productId,
    }

    const body = {
      campaigns,
      budgetType,
      budget,
      samePercentsOnCampaigns,
      percents,
      campaignPercents,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/save-all`, body, { params })

    return data
  }

  static async saveDealership({ dealerShipId, budgetType, budget, percents, productId }) {
    const params = {
      ...this.datepicker,
      productId,
    }

    const body = {
      budgetType,
      budget,
      percents,
      dealerShipId,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/save-dealership`, body, { params })

    return data
  }

  static async updateTemplate({ name, percents, templateId }) {
    const params = {
      ...this.datepicker,
      templateId,
    }

    const body = {
      name,
      percents,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/template-update`, body, { params })

    return data
  }
}
